import script from "./OperationsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./OperationsPage.vue?vue&type=script&setup=true&lang=js"

import "./OperationsPage.vue?vue&type=style&index=0&id=1089ab04&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1089ab04"]])

export default __exports__